import { MemberStateConstant, StorageConstant } from '../constants';
import { storageService } from '@life-time-inc/enterprise-framework-core';
import type { ltFramework } from '@life-time-inc/enterprise-framework-core';

export default class MemberStateService implements ltFramework.IMemberStateService {
	public getMemberState(st: string, sso: string, token: string | undefined, ct: string): string {
		let authenticated = false;
		if (sso) {
			authenticated = true;
		}

		let remembered = false;
		if ((ct || token) && !authenticated) {
			remembered = true;
		}
		else if (st) {
			authenticated = true;
		}

		let memberState = MemberStateConstant.unauthenticated;
		if (remembered) {
			memberState = MemberStateConstant.remembered;
		}
		else if (authenticated) {
			memberState = MemberStateConstant.authenticated;
		}
		else {
			storageService.sessionRemove(StorageConstant.partyId);
			storageService.sessionRemove(StorageConstant.memberDetails);
			storageService.sessionRemove(StorageConstant.personalization);
		}

		return memberState;
	}
}

export const memberStateService = new MemberStateService();
